import {
  ADD_TO_CART,
  UPDATE_CART,
  ELIMINATE_ITEM,
  REQUEST_PRODUCT_DATABASE_PENDING,
  REQUEST_PRODUCT_DATABASE_REJECTED,
  REQUEST_PRODUCT_DATABASE_RESOLVED
} from '../actiontypes';

import {SINGLE_PAGES} from '../../URLS';

export const addToCart = (item, quantity) => ({
  type: ADD_TO_CART,
  payload: {
    item,
    quantity
  }
});

export const updateCart = (item, quantity) => ({
  type: UPDATE_CART,
  payload: {
    item,
    quantity
  }
});

export const eliminateItem = item => ({
  type: ELIMINATE_ITEM,
  payload: {item},
});

export const setProductDatabase = () => async dispatch => {
  if (!JSON.parse(localStorage.getItem("products"))) {
    try {
      const fetchBase = "https://pasteleriavalentina-server.herokuapp.com";
      dispatch({
        type: REQUEST_PRODUCT_DATABASE_PENDING
      });

      const productCategories = await fetch(`${fetchBase}/product-categories`)
      .then(resp => resp.json());
      const productDescriptions = await fetch(`${fetchBase}/product-descriptions`)
      .then(resp => resp.json());
      const prices = await fetch(`${fetchBase}/product-prices`)
      .then(resp=>resp.json());

      const payload = Object.entries(SINGLE_PAGES).reduce((curr, [productName, url]) => {
        curr.push({
          title: productName,
          price: prices[productName],
          link: url,
          category: productCategories[productName].category,
          subcategory: productCategories[productName].subcategory,
          description: productDescriptions[productName]
        });
        return curr;
      }, []);

      dispatch({
        payload,
        type: REQUEST_PRODUCT_DATABASE_RESOLVED
      });
    } catch(err) {
      dispatch({
        type: REQUEST_PRODUCT_DATABASE_REJECTED,
      })
    }
  }
}

const globals = {
  addToCart,
  updateCart,
  eliminateItem,
  setProductDatabase
};



export default globals;
